import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "menu-tag",
  "use": "menu-tag-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"menu-tag\"><defs><style>#menu-tag .cls-1{fill:none}</style></defs><title>资源 20</title><g id=\"menu-tag_图层_2\" data-name=\"图层 2\"><g id=\"menu-tag_图层_1-2\" data-name=\"图层 1\"><path d=\"M19.42 1.75H4.6A2.15 2.15 0 0 0 2.45 3.9v16.17a2.15 2.15 0 0 0 2.15 2.15h14.82a2.15 2.15 0 0 0 2.15-2.15V3.9a2.15 2.15 0 0 0-2.15-2.15zM20 20.07a.55.55 0 0 1-.55.55H4.6a.55.55 0 0 1-.55-.55V3.9a.55.55 0 0 1 .55-.55h2.19V12a.52.52 0 0 0 .31.47.53.53 0 0 0 .55-.11L10 9.93l2.28 2.4a.51.51 0 0 0 .36.15.58.58 0 0 0 .19 0 .5.5 0 0 0 .31-.47V3.35h6.24a.55.55 0 0 1 .62.55z\" /><path id=\"menu-tag_矩形_195\" data-name=\"矩形 195\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/menu-tag.svg
// module id = N8Tc
// module chunks = 6